import React from 'react'
import PropTypes from 'prop-types'
function Quiz({ styling }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      className={styling}
    >
      <path d="M60.2 27.5C39.6 27.5 23 42.1 23 60.1s16.6 32.6 37.2 32.6c7.4 0 14.4-1.9 20.2-5.2 5.2 3.1 10.9 3 14.2 2.6.9-.1 1.2-1.3.4-1.9-3.2-2.1-4.9-5-5.9-7.6 5.2-5.6 8.3-12.7 8.3-20.5 0-18-16.7-32.6-37.2-32.6zm2.5 45.8c0 .8-.7 1.5-1.5 1.5h-3.7c-.8 0-1.5-.7-1.5-1.5v-2.4c0-.8.7-1.5 1.5-1.5h3.7c.8 0 1.5.7 1.5 1.5v2.4zm5.9-14.5c-1 1.4-2.2 2.5-3.8 3.3-.8.6-1.4 1.2-1.7 1.8-.2.5-.3 1-.4 1.7 0 .5-.5.9-1 .9h-4.6c-.6 0-1.1-.5-1-1.1.1-1.3.4-2.3.9-3 .6-.9 1.8-2 3.6-3.2.9-.6 1.6-1.2 2.1-2.1.5-.8.8-1.8.8-2.8 0-1.1-.3-2-.9-2.7-.6-.7-1.4-1-2.5-1-.9 0-1.6.3-2.2.8-.4.3-.6.8-.8 1.3-.2.7-.8 1.1-1.5 1.1l-4.3-.1c-.5 0-1-.5-.9-1 .2-2.3 1-4 2.6-5.2 1.8-1.4 4.2-2.1 7.1-2.1 3.2 0 5.6.8 7.4 2.4 1.8 1.6 2.7 3.7 2.7 6.4-.1 1.7-.6 3.3-1.6 4.6zM9.5 51.2c-4.3-4.6-6.8-10.5-6.8-16.9 0-14.9 13.8-27 30.7-27 11.5 0 21.6 5.6 26.8 13.8-22.8 0-41.6 15.8-43.5 35.8-4.3 2.6-9 2.5-11.7 2.1-.8-.1-1-1.1-.3-1.5 2.5-1.8 4-4.2 4.8-6.3z" />
    </svg>
  )
}
// PROPTYPES
const { string } = PropTypes
Quiz.propTypes = {
  styling: string,
}

export default Quiz
